export default () => ({
    pendingTasks: [],
    loadingTasks: false
})

